import client from './client';

export interface HeatingSeason {
  id: number;
  season_name: string;
  start_date: string; // ISO yyyy-mm-dd
  end_date: string;
  school_closure_temp: number;
  notes?: string | null;
  is_active: boolean;
  is_heating_now?: boolean;
  days_remaining?: number;
  created_at?: string;
}

export interface HeatingSeasonCreatePayload {
  season_name: string;
  start_date: string;
  end_date: string;
  school_closure_temp: number;
  notes?: string;
}

export type HeatingSeasonUpdatePayload = Partial<HeatingSeasonCreatePayload> & {
  is_active?: boolean;
};

export const heatingApi = {
  list: async (): Promise<HeatingSeason[]> => {
    const { data } = await client.get('/api/admin/heating');
    return data;
  },
  create: async (payload: HeatingSeasonCreatePayload): Promise<HeatingSeason> => {
    const { data } = await client.post('/api/admin/heating', payload);
    return data;
  },
  update: async (id: number, payload: HeatingSeasonUpdatePayload): Promise<HeatingSeason> => {
    const { data } = await client.patch(`/api/admin/heating/${id}`, payload);
    return data;
  },
  sendSchoolClosurePush: async (): Promise<{ sent: number; message: string }> => {
    const { data } = await client.post('/api/admin/heating/school-closure-push');
    return data;
  },
};
